import React from "react";

import CommonCard from "../CommonCard/index";

const FruitKatliRange = ({ products, title }) => {
    return (
        <>
            <CommonCard
                products={products}
                title={title}
            />
        </>
    );
};

export default FruitKatliRange;